import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LinerServiceFormComponent } from "./liner-service-form/liner-service-form.component";
import { LinerServiceListComponent } from "./liner-service-list/liner-service-list.component";

const routes:Routes=[
    {
       path:'',
       data:{
           title:'Liner Service'
       },
       component:LinerServiceListComponent
    },
    {
        path:'add',
        data:{
            title:'Add Liner Service'
        },
        component:LinerServiceFormComponent
    },
    {
        path:'edit/:id',
        data:{
            title:'Edit Liner Service'
        },
        component:LinerServiceFormComponent
    }
]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})

export class LinerServiceRoutingModule{

}